// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","824":"component---src-templates-doc-js"}[chunkId] || chunkId) + "-" + {"125":"ff0e1f3799faa06ad5bc","293":"e7bc957b0412651a2c09","454":"96edd733be612d204586","824":"8f9568fffe8aa6d0e778"}[chunkId] + ".js";
};